module.exports = __webpack_public_path__ + "img/649206d.png";